import React from "react";
import { useLocalization } from "@fluent/react";
import { Chip } from "@narmi/design_system";
import {
  BYZANTINE_COPY_TO_FLUENT_ID,
  STATUS_CHIP_KINDS,
  STATUS_CHIP_ICONS,
} from "./OrganizationUsers.constants";

type OrganizationUserStatusChipProps = {
  status: string;
};

const OrganizationUserStatusChip: React.FC<OrganizationUserStatusChipProps> = ({
  status,
}) => {
  const { l10n } = useLocalization();

  return (
    <Chip
      startIcon={STATUS_CHIP_ICONS[status] as any}
      kind={STATUS_CHIP_KINDS[status] as any}
      label={l10n.getString(BYZANTINE_COPY_TO_FLUENT_ID[status])}
    />
  );
};

export default OrganizationUserStatusChip;
